import { faSpinner, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ChangeEvent, useRef } from "react";
import { useUploadAndTransformContentImage } from "../../../../services/vod/Query";
import { Content, ContentGroup, ImageEntityInstanceType, ImageUpload } from "../../../../models/vod/Models";

interface Props {
    asset: Content | ContentGroup;
    imageEntityType: ImageEntityInstanceType;
}

const FileUpload = ({ asset, imageEntityType } : Props) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const uploadAndTransformImage = useUploadAndTransformContentImage();

    const assetType = Object.prototype.hasOwnProperty.call(asset, "contentType") ? "content" : "content-group";
    const data = { asset, assetType, imageType: imageEntityType } as ImageUpload;
    const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target?.files?.[0];

        if (!file) return;

        data.file = file;
        await uploadAndTransformImage.mutateAsync(data);

        e.target.value = "";
    };

    return (
        <>
            <button
                data-tooltip-content= {`${uploadAndTransformImage.isPending ? "Uploading" : "Upload"} file`}
                data-tooltip-id="global-tooltip"
                onClick={() => inputRef?.current?.click()}
            >
                {
                    uploadAndTransformImage.isPending
                        ? <FontAwesomeIcon icon = {faSpinner} spin className = "text-brand-300" />
                        : <FontAwesomeIcon icon = {faUpload} className = "hover:cursor-pointer text-brand-300" />
                }
            </button>
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                className={`hidden`}
                onChange={handleChange}
            />
        </>
    );
};

export default FileUpload;